<template>
<div class="bottom-menu">
  <div class="row">
    <div class="col col--left text size-large">
      <nav>
        <a href="#" @click.prevent="$store.dispatch('scrollToTop')">Return <br />to top</a>
      </nav>
    </div>

    <div class="col text nav size-large">
      <nav-items position="bottom"></nav-items>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
export default Vue.component('bottom-menu', {})
</script>

<style scoped lang="scss">
@import '~@/_variables.scss';

.bottom-menu {
  color: $color-white;
  text-transform: uppercase;
  padding-bottom: 4rem;
  .row {
    display: flex;
    .col {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      &--left nav {
        padding-left: $gutter;
      }
    }
    .text {
      line-height: 1;
      padding: $gutter $gutter $gutter 0;
      width: 50%;
      @media (max-width: $break-small) {
        line-height: 1.1;
        font-size: $size-medium;
      }
    }
  }
  @media (min-width: #{$break-small + 1px}) {
    a br {
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bottom-menu.vue